<template>
    <div class="container">
        <v-btn class="pa-4" color="primary" height="25%" width="80%" rounded @click="salePage">
            พนักงานขาย
        </v-btn>
        <!-- <v-btn class="pa-4" color="primary" height="25%" width="80%" rounded @click="engineerPage">
            ช่าง
        </v-btn> -->
        <v-btn class="pa-4" color="primary" height="25%" width="80%" rounded @click="saleEngineerListPage">
            ประวัติ
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'CheckInMenu',

    data () {
        return {

        }
    },

    methods: {
        salePage () {
            this.$router.push('/check-in-sale')
        },

        engineerPage () {
            this.$router.push('/check-in-engineer')
        },

        saleEngineerListPage () {
            this.$router.push('/check-in-sale-list')
        }
    },

    mounted () {

    }
}
</script>
<style scoped>
::v-deep.v-btn.v-size--default {
    font-size: 40px ;
}
.container {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    gap: 2rem;
    width: 100%;
    height: 100%;
}

</style>
